import {
  getClearanceMaterials,
  getClearanceMaterialsCSV,
  sendByEmailClearanceMaterials,
} from '@/repositories/Materials';

export default {
  namespaced: true,
  state: {
    materials: [],
    loading: false,
    error: '',
  },

  getters: {
    clearanceMaterials: (state) => state.materials,
    loadingMaterials: (state) => state.loading,
    clearanceMaterialsCount: (state) => state.materials.length,
    loadingError: (state) => state.error,
  },

  mutations: {
    SET_MATERIALS(state, materials) {
      state.materials = materials;
    },

    RESET_STORE(state) {
      state.materials = [];
      state.error = '';
    },

    SET_LOADING(state, status) {
      state.loading = status;
    },

    SET_ERROR(state, msg) {
      state.error = msg;
    },
  },

  actions: {
    async loadClearanceMaterials({ rootGetters, commit }, payload) {
      commit('SET_ERROR', '');
      const channel = rootGetters['auth/channel'];

      if (channel) {
        commit('SET_LOADING', true);
        try {
          const materials = await getClearanceMaterials(
            channel,
            payload.customer,
            payload.center
          );
          commit('SET_MATERIALS', materials);
        } catch (error) {
          commit(
            'SET_ERROR',
            'No se pudo obtener la lista de productos en liquidación'
          );
        }

        commit('SET_LOADING', false);
      } else {
        commit('RESET_STORE');
      }
    },

    async getCSVFile({ rootGetters }, payload) {
      const channel = rootGetters['auth/channel'];

      try {
        const file = await getClearanceMaterialsCSV(
          channel,
          payload.customer,
          payload.center
        );
        return { ok: true, file };
      } catch (error) {
        return { ok: false, message: 'Sucedió un error al generar el archivo' };
      }
    },

    async sendByEmail({ rootGetters }, payload) {
      const channel = rootGetters['auth/channel'];

      try {
        await sendByEmailClearanceMaterials(
          channel,
          payload.email,
          payload.customer,
          payload.center
        );
        return { ok: true };
      } catch (error) {
        return { ok: false, message: 'Sucedió un error al enviar el correo' };
      }
    },

    cleanClearanceMaterials({ commit }) {
      commit('RESET_STORE');
    },
  },
};
